import { useEffect, useRef, useState } from 'react';

// Web Audio API ile bildirim sesi üretir (harici dosyaya gerek yok)
function playNotificationSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    
    const playBeep = (freq, startTime, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, startTime);
      gain.gain.setValueAtTime(0, startTime);
      gain.gain.linearRampToValueAtTime(0.35, startTime + 0.01);
      gain.gain.linearRampToValueAtTime(0, startTime + duration);
      osc.start(startTime);
      osc.stop(startTime + duration);
    };

    const now = ctx.currentTime;
    playBeep(880, now, 0.12);
    playBeep(1100, now + 0.13, 0.15);
  } catch (e) {
    // Ses API yoksa sessizce geç
  }
}

/**
 * Yeni randevu, mesaj veya ön görüşme olduğunda ses çalar.
 * soundEnabled: localStorage'dan okunur ve yazılır.
 */
export function useNotificationSound() {
  const [soundEnabled, setSoundEnabled] = useState(() => {
    return localStorage.getItem('notif_sound') !== 'off';
  });

  const lastAppointmentId = useRef(null);
  const lastMessageId = useRef(null);
  const lastPreConsultId = useRef(null);
  const initialized = useRef(false);

  const toggleSound = () => {
    setSoundEnabled(prev => {
      const next = !prev;
      localStorage.setItem('notif_sound', next ? 'on' : 'off');
      return next;
    });
  };

  useEffect(() => {
    const token = () => localStorage.getItem('crm_token');

    const fetchLatestId = async (endpoint) => {
      try {
        const res = await fetch(endpoint, {
          headers: { Authorization: `Bearer ${token()}` }
        });
        if (!res.ok) return null;
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) return data[0].id;
        return null;
      } catch { return null; }
    };

    const checkAll = async () => {
      const [apptId, msgId, preId] = await Promise.all([
        fetchLatestId('/api/appointments?limit=1'),
        fetchLatestId('/api/messages?limit=1'),
        fetchLatestId('/api/pre-consultations?limit=1'),
      ]);

      if (!initialized.current) {
        // İlk yükleme: sadece referans değerleri kaydet, ses çalma
        lastAppointmentId.current = apptId;
        lastMessageId.current = msgId;
        lastPreConsultId.current = preId;
        initialized.current = true;
        return;
      }

      const hasNew =
        (apptId && apptId !== lastAppointmentId.current) ||
        (msgId && msgId !== lastMessageId.current) ||
        (preId && preId !== lastPreConsultId.current);

      if (hasNew && soundEnabled) {
        playNotificationSound();
      }

      if (apptId) lastAppointmentId.current = apptId;
      if (msgId) lastMessageId.current = msgId;
      if (preId) lastPreConsultId.current = preId;
    };

    const interval = setInterval(checkAll, 8000); // Her 8 saniyede bir
    checkAll(); // İlk çalıştırma

    return () => clearInterval(interval);
  }, [soundEnabled]);

  return { soundEnabled, toggleSound };
}
